module.exports = __webpack_public_path__ + "static/media/mx.7fd6e432.svg";